import { cloneDeep, get, isArray, set } from 'lodash';
import {
	ANTRAG_ASSO_PARTNER,
	ANTRAG_VERBUNDPARTNER,
	BEIHILFERELEVANZ_PATH,
	EMOB_LIS_STANDORTE_PATHS,
	KMU_PATHS,
	RUS_PATH,
} from 'src/lib/constants/componentsPath';
import { ANTRAGS_FORMULAREN, PRUEF_ASSISTENZ_STATUS } from 'src/lib/constants/constant';
import { addIndexesToPath, isTrue } from 'src/utils/helper';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

// Projektdaten
function checkIfProjektDatenHasComment(readOnly: boolean, application: any): boolean {
	const pruefStatusPath = P.Allgemein_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
}
// Antragstellende
function checkIfAntragstellendeHasComment(readOnly: boolean, application: any): boolean {
	const pruefStatusPath = P.Antragstellende_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
}
// Alle oder einzel Partner
function checkIfAnyPartnerHasComment(readOnly: boolean, application: any, isPartnerAssoziiert: boolean = false): boolean {
	if (readOnly) return false;
	let hasComment = false;

	if (isTrue(isPartnerAssoziiert)) {
		const allAssoPartner = get(application, P.Assoziierte_Partner.path, []);
		if (isArray(allAssoPartner) && allAssoPartner.length > 0) {
			for (const eachPartner of allAssoPartner) {
				if (get(eachPartner, ANTRAG_ASSO_PARTNER.UeberarbeitungHinweisStatus) === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
					hasComment = true;
					return true;
				}
			}
		}
		return hasComment;
	} else {
		const allVPartner = get(application, P.Verbundpartner.path, []);
		if (isArray(allVPartner) && allVPartner.length > 0) {
			for (const eachPartner of allVPartner) {
				if (get(eachPartner, ANTRAG_VERBUNDPARTNER.UeberarbeitungHinweisStatus) === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
					hasComment = true;
					return true;
				}
			}
		}
		return hasComment;
	}
}
function checkIfSpecificPartnerHasComment(readOnly: boolean, partnerObj: any): boolean {
	return checkIfHasComment(readOnly, partnerObj, ANTRAG_VERBUNDPARTNER.UeberarbeitungHinweisStatus);
}
function checkIfSpecificAssoPartnerHasComment(readOnly: boolean, partnerObj: any): boolean {
	return checkIfHasComment(readOnly, partnerObj, ANTRAG_ASSO_PARTNER.UeberarbeitungHinweisStatus);
}
// Alle oder einzel KMU
function checkIfAnyKmusHasComment(readOnly: boolean, application: any): boolean {
	if (readOnly) return false;
	let hasComment = false;

	const allKmus = get(application, P.Selbsterklaerung_KMU.path, []);

	if (isArray(allKmus) && allKmus.length > 0) {
		for (const eachKmu of allKmus) {
			if (get(eachKmu, KMU_PATHS.Prufueng_Prufstatus) === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
				hasComment = true;
				return true;
			}
		}
	}
	return hasComment;
}
const checkIfSpecificKmuHasComment = (readOnly: boolean, application: any, unternehmensId: number, positionId?: string) => {
	if (readOnly) return false;
	let hasComment = false;
	const allKmus = get(application, P.Selbsterklaerung_KMU.path, []);

	if (isArray(allKmus) && allKmus.length > 0) {
		const selectedKmu_Obj = allKmus.find(
			(ele: any) => get(ele, `${KMU_PATHS.Unternehmen}.id`, -1) === unternehmensId || get(ele, KMU_PATHS.PositionID, '') === positionId,
		);
		if (get(selectedKmu_Obj, KMU_PATHS.Prufueng_Prufstatus) === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
			hasComment = true;
			return true;
		}
	}
	return hasComment;
};
// Alle oder einzel RUS
const checkIfAnyRUSHasComment = (readOnly: boolean, application: any): boolean => {
	if (readOnly) return false;
	let hasComment = false;

	const all_RUS = get(application, P.Selbsterklaerung_RUS.path, []);
	if (isArray(all_RUS) && all_RUS.length > 0) {
		for (const eachELement of all_RUS) {
			if (get(eachELement, RUS_PATH.Prufueng_Prufstatus, '') === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
				hasComment = true;
				return true;
			}
		}
	}
	return hasComment;
};
const checkIfSelectedRUSHasComment = (readOnly: boolean, application: any, unternehmensId: number, positionId?: string) => {
	if (readOnly) return false;
	let hasComment = false;
	const all_RUS = get(application, P.Selbsterklaerung_RUS.path, []);
	if (isArray(all_RUS) && all_RUS.length > 0) {
		const selectedKmu_Obj = all_RUS.find(
			(ele: any) => get(ele, `${RUS_PATH.Unternehmen}.id`, -1) === unternehmensId || get(ele, RUS_PATH.PositionID, '') === positionId,
		);
		if (get(selectedKmu_Obj, RUS_PATH.Prufueng_Prufstatus, '') === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
			hasComment = true;
			return true;
		}
	}
	return hasComment;
};
const checkIfAnyBeihilferelevanzHasComment = (readOnly: boolean, application: any): boolean => {
	if (readOnly) return false;
	let hasComment = false;

	const all_Beihilferelevanz = get(application, P.Beihilferelevanz_Selbsterklaerung.path, []);
	if (isArray(all_Beihilferelevanz) && all_Beihilferelevanz.length > 0) {
		for (const eachElement of all_Beihilferelevanz) {
			if (get(eachElement, BEIHILFERELEVANZ_PATH.Pruefung_Pruefstatus, '') === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
				hasComment = true;
				return true;
			}
		}
	}
	return hasComment;
};
const checkIfSelectedBeihilferelevanzHasComment = (
	readOnly: boolean,
	application: any,
	unternehmensId: number,
	positionId?: string,
) => {
	if (readOnly) return false;
	let hasComment = false;
	const all_Beihilferelevanz = get(application, P.Beihilferelevanz_Selbsterklaerung.path, []);
	if (isArray(all_Beihilferelevanz) && all_Beihilferelevanz.length > 0) {
		const selectedObj = all_Beihilferelevanz.find(
			(ele: any) =>
				get(ele, `${BEIHILFERELEVANZ_PATH.Unternehmen}.id`, -1) === unternehmensId ||
				get(ele, BEIHILFERELEVANZ_PATH.PositionID, '') === positionId,
		);
		if (get(selectedObj, BEIHILFERELEVANZ_PATH.Pruefung_Pruefstatus, '') === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
			hasComment = true;
			return true;
		}
	}
	return hasComment;
};
// De-Minimis
const checkIfDeminimisHasComment = (readOnly: boolean, application: any): boolean => {
	const pruefStatusPath = P.Deminimis_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
};

// Standorte
function checkIfAnyStandorteHasComment(readOnly: boolean, application: any): boolean {
	if (readOnly) return false;
	let hasComment = false;

	const allStandorte = get(
		application,
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path,
		[],
	);
	if (isArray(allStandorte) && allStandorte.length > 0) {
		for (const eachELement of allStandorte) {
			if (get(eachELement, EMOB_LIS_STANDORTE_PATHS.Prufueng_Prufstatus, '') === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
				hasComment = true;
				return true;
			}
		}
	}
	return hasComment;
}
function checkIfSpecificStandorteHasComment(readOnly: boolean, application: any, standortId: number): boolean {
	if (readOnly) return false;
	let hasComment = false;
	const allStandorte = get(
		application,
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path,
		[],
	);
	if (isArray(allStandorte) && allStandorte.length > 0) {
		const selectedStandort_Obj = allStandorte.find((ele: any) => get(ele, `${EMOB_LIS_STANDORTE_PATHS.GroupId}.id`, -1) === standortId);
		if (get(selectedStandort_Obj, EMOB_LIS_STANDORTE_PATHS.Prufueng_Prufstatus, '') === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
			hasComment = true;
			return true;
		}
	}
	return hasComment;
}

// Zeitplanung
function checkIfZeitplaungHasComment(readOnly: boolean, application: any): boolean {
	const pruefStatusPath = P.Zeitplanung_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
}
// Anlagen
function checkIfAnlagenHasComment(readOnly: boolean, application: any): boolean {
	const pruefStatusPath = P.Pruefung_Anlagen_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
}
// Erklärungen
function checkIfErklaerungenHasComment(readOnly: boolean, application: any): boolean {
	const pruefStatusPath = P.Erklaerungen_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
}

/**
 * KOSTENPOSITIONEN
 */

// Prüft, ob alle KostenPositionen bearbeitbar sind.
const checkIfAllPositionIsEditable = (readOnly: boolean, application: any): boolean => {
	const pruefvermekAusgaben = checkIfAusgabenPruefvermerkHasComment(readOnly, application);
	const pruefvermekFinanzierung = checkIfFinanzierungsPruefvermerkHasComment(readOnly, application);
	const pruefVermekrAUF = checkIfAUFPruefvermerkHasComment(readOnly, application);

	const hasAnyKostenPositionComment = checkIfAnyKostenPositionHasComment(readOnly, application);

	return pruefvermekAusgaben || pruefvermekFinanzierung || pruefVermekrAUF || hasAnyKostenPositionComment;
};
// Prüft, ob mindestens ein KostensPosition eine Prüfstatus in Überarbeitung hat, um die Prüfbox anzuzeigen
const checkIfAnyKostenPositionHasComment = (readOnly: boolean, application: any): boolean => {
	if (readOnly) return false;

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	return allKostenPosition.some((ele: any) => {
		const hasComment = checkIfHasComment(readOnly, ele, KP_P.Pruefung_Pruefstatus.path);
		return hasComment;
	});
};

// Prüft, ob mindestens ein KostenPosition mit bestimmter Kostenart eine Prüfstatus in Überarbeitung hat, um die Prüfbox anzuzeigen
// Diese Funktion wird im Baum bei TreeStructure für einzelne Kostenarten verwendet.
const checkIfAnyPositionNachKostenArtHasComment = (readOnly: boolean, application: any, kostenArt: string) => {
	if (readOnly) return false;

	let hasComment = false;

	const allKostenPostion = get(application, P.Foerderantrag_Kostenpositions.path, []);
	let filteredKostenPosition = allKostenPostion.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === kostenArt);

	for (const ele of filteredKostenPosition) {
		if (get(ele, KP_P.Pruefung_Pruefstatus.path) === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
			hasComment = true;
			return true;
		}
	}

	return hasComment;
};

// Prüft, ob mindestens ein KostenPosition mit bestimmter kostenposition ("Ausgaben" oder "Einnahmen") eine Prüfstatus in Überarbeitung hat, um die Prüfbox anzuzeigen
// Diese Funktion wird im Baum bei TreeStructure für einzelne Kostenarten verwendet.
// DerZeit wird nur für Messeförderung verwendet
const checkIfAnyPositionNachPositionArtHasComment = (readOnly: boolean, application: any, positionArt: string) => {
	if (readOnly) return false;

	let hasComment = false;

	const allKostenPostion = get(application, P.Foerderantrag_Kostenpositions.path, []);
	let filteredKostenPosition = allKostenPostion.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === positionArt);

	for (const ele of filteredKostenPosition) {
		if (get(ele, KP_P.Pruefung_Pruefstatus.path) === PRUEF_ASSISTENZ_STATUS.uberarbeitung) {
			hasComment = true;
			return true;
		}
	}

	return hasComment;
};

// Prüft, ob die spezifische Kostenposition eine Prüfstatus in Überarbeitung hat, um die Prüfbox anzuzeigen
// Diese Funktion wird für einzelne Kostenpositionen (Akkordion) verwendet
const checkIfSpecificKostenPositionHasComment = (readOnly: boolean, kostenPositionObj: any) => {
	if (readOnly) return false;
	return checkIfHasComment(readOnly, kostenPositionObj, KP_P.Pruefung_Pruefstatus.path);
};

// Prüft, ob im Antrag -> Prüfvermekt für Ausgabenplan, Finanzierungsplan oder Ausgaben und Finanzierungsplan der Status zur Überarbeitung gesetzt ist, um die Prüfbox anzuzeigen
const checkIfAusgabenPruefvermerkHasComment = (readOnly: boolean, application: any): boolean => {
	const pruefStatusPath = P.Ausgabenplan_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
};
const checkIfFinanzierungsPruefvermerkHasComment = (readOnly: boolean, application: any): boolean => {
	const pruefStatusPath = P.Finanzierungsplan_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
};
const checkIfAUFPruefvermerkHasComment = (readOnly: boolean, application: any): boolean => {
	const pruefStatusPath = P.AUF_Gesamt_Pruefung_Pruefstatus.path;
	return checkIfHasComment(readOnly, application, pruefStatusPath);
};

const checkIfHasComment = (readOnly: boolean, application: any, statusPath: string) => {
	if (readOnly) return false;
	if (get(application, statusPath, '') === PRUEF_ASSISTENZ_STATUS.uberarbeitung) return true;
	return false;
};

const updatePruefAssistenzStatus = (updateRecord: any) => {
	const appCopy = cloneDeep(updateRecord);
	const paths = PruefAssistenzPaths(appCopy);

	function isLeafNode(pathObj: any): boolean {
		return Boolean(pathObj?.PruefStatus && pathObj?.IstErledigt);
	}

	function isArrayNode(pathObj: any): boolean {
		return Boolean(pathObj?.isArray && pathObj?.ArrayPath);
	}

	function updateLeafNode(obj: any, pathObj: any, indexes: number[] = [], arrayKeys: string[] = []) {
		const strIndexes = indexes.map(String);

		const pruefStatusPath = addIndexesToPath(pathObj.PruefStatus, strIndexes, arrayKeys);
		const istErledigtPath = addIndexesToPath(pathObj.IstErledigt, strIndexes, arrayKeys);
		const ueberarbeitetAmPath = pathObj.UeberarbeitetAm ? addIndexesToPath(pathObj.UeberarbeitetAm, strIndexes, arrayKeys) : null;

		const pruefStatus = get(obj, pruefStatusPath);
		const istErledigt = get(obj, istErledigtPath);

		const shouldResetStatus = pruefStatus === PRUEF_ASSISTENZ_STATUS.uberarbeitung && istErledigt === true;

		if (shouldResetStatus) {
			set(obj, pruefStatusPath, PRUEF_ASSISTENZ_STATUS.ungeprüft);

			if (ueberarbeitetAmPath) {
				set(obj, ueberarbeitetAmPath, new Date());
			}
		}
	}

	function traversePathConfig(obj: any, pathObj: any, indexes: number[] = [], arrayKeys: string[] = []) {
		if (!pathObj || typeof pathObj !== 'object') return;

		// Fall 1: Array-Knoten
		if (isArrayNode(pathObj)) {
			const arr = get(obj, pathObj.ArrayPath, []);

			if (!isArray(arr)) return;

			arr.forEach((_item: any, idx: number) => {
				// Bei deiner Struktur ist der Array-Knoten selbst auch schon der Leaf
				if (isLeafNode(pathObj)) {
					updateLeafNode(obj, pathObj, [...indexes, idx], [...arrayKeys, pathObj.ArrayPath]);
				}
			});

			return;
		}

		// Fall 2: Einfacher Leaf-Knoten
		if (isLeafNode(pathObj)) {
			updateLeafNode(obj, pathObj, indexes, arrayKeys);
			return;
		}

		// Fall 3: Verschachtelte Konfigurationsobjekte weiter traversieren
		for (const key of Object.keys(pathObj)) {
			if (key === 'isArray' || key === 'ArrayPath') continue;

			const child = pathObj[key];

			if (child && typeof child === 'object') {
				traversePathConfig(obj, child, indexes, arrayKeys);
			}
		}
	}

	traversePathConfig(appCopy, paths);

	return appCopy;
};

export {
	checkIfAllPositionIsEditable,
	checkIfAnlagenHasComment,
	checkIfAntragstellendeHasComment,
	checkIfAnyKmusHasComment,
	checkIfAnyKostenPositionHasComment,
	checkIfAnyPartnerHasComment,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfAnyPositionNachPositionArtHasComment,
	checkIfAnyRUSHasComment,
	checkIfAnyStandorteHasComment,
	checkIfAnyBeihilferelevanzHasComment,
	checkIfDeminimisHasComment,
	checkIfErklaerungenHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
	checkIfSelectedRUSHasComment,
	checkIfSelectedBeihilferelevanzHasComment,
	checkIfSpecificAssoPartnerHasComment,
	checkIfSpecificKmuHasComment,
	checkIfSpecificKostenPositionHasComment,
	checkIfSpecificPartnerHasComment,
	checkIfSpecificStandorteHasComment,
	checkIfZeitplaungHasComment,
	updatePruefAssistenzStatus,
};

/**
 *
 * @returns All the paths for the Prüfboxes
 */
const PruefAssistenzPaths = (application: any) => {
	return {
		// Hier sind alle Pfade für die Prüfboxen definiert. Es kann auch tief verschachtelt sein, siehe Verbundpartner -> Ansprechpartner
		Projektdaten: {
			PruefStatus: P.Allgemein_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			UeberarbeitetAm: P.Allgemein_Pruefung_Ueberarbeitet_Am.path,
			IstErledigt: P.Allgemein_Pruefung_Erledigt.path,
		},
		Antragsteller: {
			PruefStatus: P.Antragstellende_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Antragstellende_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			UeberarbeitetAm: P.Antragstellende_Pruefung_Ueberarbeitet_Am.path,
			IstErledigt: P.Antragstellende_Pruefung_Erledigt.path,
		},
		DeMinimis: {
			PruefStatus: P.Deminimis_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Deminimis_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			UeberarbeitetAm: P.Deminimis_Pruefung_Ueberarbeitet_Am.path,
			IstErledigt: P.Deminimis_Pruefung_Erledigt.path,
		},
		Verbundpartner: {
			isArray: true,
			ArrayPath: P.Verbundpartner.path,
			PruefStatus: P.Verbundpartner.schema.attributes.Verbundpartner_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Verbundpartner.schema.attributes.Verbundpartner_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			UeberarbeitetAm: P.Verbundpartner.schema.attributes.Verbundpartner_Pruefung_Ueberarbeitet_Am.path,
			IstErledigt: P.Verbundpartner.schema.attributes.Verbundpartner_Pruefung_Erledigt.path,

			// Tief verschachtelt als Beispiel
			// Ansprechpartner: {
			// 	isArray: true,
			// 	ArrayPath: P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.path,
			// 	PruefStatus: P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.schema.attributes.Titel.path,
			// 	PruefHinweis: P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.schema.attributes.Titel.path,
			// 	UeberarbeitetAm: P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.schema.attributes.Titel.path,
			// 	IstErledigt: P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.schema.attributes.Titel.path,
			// },
		},
		// In Assoziierte Partner gibt es noch keine Prüfboxen
		Assoziierte_Partner: {
			isArray: true,
			ArrayPath: P.Assoziierte_Partner.path,
			PruefStatus: P.Assoziierte_Partner.schema.attributes.Pruefstatus.path,
			PruefHinweis: P.Assoziierte_Partner.schema.attributes.Hinweis_Fuer_Den_Antragsteller.path,
			UeberarbeitetAm: P.Assoziierte_Partner.schema.attributes.Ueberarbeitet_Am.path,
			IstErledigt: P.Assoziierte_Partner.schema.attributes.Erledigt_Durch_Antragsteller.path,
		},
		SelbstErklaerung_KMU: {
			isArray: true,
			ArrayPath: P.Selbsterklaerung_KMU.path,
			PruefStatus: P.Selbsterklaerung_KMU.schema.attributes.Kmu_Pruefstatus.path,
			PruefHinweis: P.Selbsterklaerung_KMU.schema.attributes.Kmu_Hinnweis_Antragsteller.path,
			IstErledigt: P.Selbsterklaerung_KMU.schema.attributes.Kmu_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Selbsterklaerung_KMU.schema.attributes.Kmu_Ueberarbeitet_Am.path,
		},
		Selbsterklaerung_RUS: {
			isArray: true,
			ArrayPath: P.Selbsterklaerung_RUS.path,
			PruefStatus: P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Hinnweis_Antragsteller.path,
			IstErledigt: P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Ueberarbeitet_Am.path,
		},
		Vorzeitiger_Vorhabenbeginn: {
			PruefStatus: P.Vorzeitiger_Vorhabenbeginn.schema.attributes.Vorzeitiger_Vorhabenbeginn_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Vorzeitiger_Vorhabenbeginn.schema.attributes.Vorzeitiger_Vorhabenbegin_hinnweis_Fuer_Den_Antragsteller.path,
			IstErledigt: P.Vorzeitiger_Vorhabenbeginn.schema.attributes.Vorzeitiger_Vorhabenbeginn_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Vorzeitiger_Vorhabenbeginn.schema.attributes.Vorzeitiger_Vorhabenbeginn_Pruefung_Ueberarbeitet_Am.path,
		},
		Zeitplanung: {
			PruefStatus: P.Zeitplanung_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Zeitplanung_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			IstErledigt: P.Zeitplanung_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Zeitplanung_Pruefung_Ueberarbeitet_Am.path,
		},
		Erklaerungen: {
			PruefStatus: P.Erklaerungen_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Erklaerungen_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			IstErledigt: P.Erklaerungen_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Erklaerungen_Pruefung_Ueberarbeitet_Am.path,
		},
		Anlagen: {
			PruefStatus: P.Pruefung_Anlagen_Pruefstatus.path,
			PruefHinweis: P.Pruefung_Anlagen_Hinweis_Fuer_Den_Antragsteller.path,
			IstErledigt: P.Pruefung_Anlagen_Erledigt.path,
			UeberarbeitetAm: P.Pruefung_Anlagen_Ueberarbeitet_Am.path,
		},
		AusgabenPlan: {
			PruefStatus: P.Ausgabenplan_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Ausgabenplan_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			IstErledigt: P.Ausgabenplan_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Ausgabenplan_Pruefung_Ueberarbeitet_Am.path,
		},
		Finanzierungsplan: {
			PruefStatus: P.Finanzierungsplan_Pruefung_Pruefstatus.path,
			PruefHinweis: P.Finanzierungsplan_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			IstErledigt: P.Finanzierungsplan_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Finanzierungsplan_Pruefung_Ueberarbeitet_Am.path,
		},
		AusgabenUndFinanzierungsPlan: {
			PruefStatus: P.AUF_Gesamt_Pruefung_Pruefstatus.path,
			PruefHinweis: P.AUF_Gesamt_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			IstErledigt: P.AUF_Gesamt_Pruefung_Erledigt.path,
			UeberarbeitetAm: P.AUF_Gesamt_Pruefung_Ueberarbeitet_Am.path,
		},
		// KostenPositionen
		KostenPosition: {
			isArray: true,
			ArrayPath: P.Foerderantrag_Kostenpositions.path,
			PruefStatus: P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
			PruefHinweis: P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
			IstErledigt: P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
			UeberarbeitetAm: P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
		},
		...PruefAssistenzAbhaengigeFelder(application),
	};
};

const PruefAssistenzAbhaengigeFelder = (application: any) => {
	let paths = {};

	const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');

	switch (antragsFormular) {
		// Emob Invest
		case ANTRAGS_FORMULAREN.EmobInvest:
			return {
				Ausgangsituation: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0109726323_tuation_Pruefung_Pruefstatus
							.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0250110818_nweis_Fuer_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0243997268_ssituation_Pruefung_Erledigt
							.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0180972573_on_Pruefung_Ueberarbeitet_Am
							.path,
				},
				TechnischeSpezifikationElektrofahrzeug: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0097856355_ahrzeug_Pruefung_Pruefstatus
							.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0166927874_nweis_Fuer_Den_Antragsteller
							.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0211431332_rofahrzeug_Pruefung_Erledigt
							.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0165294973_ug_Pruefung_Ueberarbeitet_Am
							.path,
				},
				TechnischeSpezifikationLadeinfrastruktur: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0035907651_truktur_Pruefung_Pruefstatus
							.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0148179138_nweis_Fuer_Den_Antragsteller
							.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0145248452_rastruktur_Pruefung_Erledigt
							.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0217957821_ur_Pruefung_Ueberarbeitet_Am
							.path,
				},
				Wasserstoff: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0235756515_sanlage_Pruefung_Pruefstatus
							.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0159442450_nweis_Fuer_Den_Antragsteller
							.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0227709476_ungsanlage_Pruefung_Erledigt
							.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0156363533_ge_Pruefung_Ueberarbeitet_Am
							.path,
				},
				AusschreibungVergabe: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0068448995_Vergabe_Pruefung_Pruefstatus
							.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0108452210_nweis_Fuer_Den_Antragsteller
							.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0251802548_nd_Vergabe_Pruefung_Erledigt
							.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0039580205_be_Pruefung_Ueberarbeitet_Am
							.path,
				},
				SonstigeInformation: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0167902019_ationen_Pruefung_Pruefstatus
							.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0165473010_nweis_Fuer_Den_Antragsteller
							.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0127455972_ormationen_Pruefung_Erledigt
							.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0167110573_en_Pruefung_Ueberarbeitet_Am
							.path,
				},
			};
		// Emob F&E
		case ANTRAGS_FORMULAREN.EmobFundE:
			return {
				Ausgangsituation: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0213069123_tuation_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0266237954_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0217627076_ssituation_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0267605373_on_Pruefung_Ueberarbeitet_Am.path,
				},
				BeschreibungDesVorhabens: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0096703458_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0106506068_Vorhabens_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0099269789_ns_Pruefung_Ueberarbeitet_Am.path,
				},
				Marktausblick: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0149595523_wertung_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0119161730_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0074775636_Verwertung_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0121048317_ng_Pruefung_Ueberarbeitet_Am.path,
				},
				SWOT: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0260019443_erungen_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0074298450_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0023299332_orderungen_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0138451405_en_Pruefung_Ueberarbeitet_Am.path,
				},
			};
		// Emonb LIS
		case ANTRAGS_FORMULAREN.EmobLis:
			return {
				Foerdervoraussetzung: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0148514099_tzungen_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0128586498_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0209715028_ssetzungen_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0126303357_en_Pruefung_Ueberarbeitet_Am.path,
				},
				Ausgangsituation: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0030170675_tuation_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0045031698_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0231697972_ssituation_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0244197901_on_Pruefung_Ueberarbeitet_Am.path,
				},
				Standort: {
					isArray: true,
					ArrayPath: P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path,
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
							.Projektbeschreibung_Elek_0211814995_truktur_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
							.Projektbeschreibung_Elek_0248403234_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
							.Projektbeschreibung_Elek_0176797940_rastruktur_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
							.Projektbeschreibung_Elek_0182666845_ur_Pruefung_Ueberarbeitet_Am.path,
				},
				SonstigeInformation: {
					PruefStatus:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0239910483_ationen_Pruefung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0047227314_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0063542836_ormationen_Pruefung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0249670381_en_Pruefung_Ueberarbeitet_Am.path,
				},
			};
		// Messeförderung
		case ANTRAGS_FORMULAREN.Messefoerderung:
			return {
				Projektbeschreibung: {
					PruefStatus: P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Pruefstatus.path,
					PruefHinweis: P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteili_0142701586_nweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Erledigt.path,
					UeberarbeitetAm: P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Ueberarbeitet_Am.path,
				},
			};
		// Start-Up-Projekte
		case ANTRAGS_FORMULAREN.StartUpProjekte:
			return {
				Vorhabensbeschreibung: {
					PruefStatus: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Vorhabensbeschreibung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Vorhabensbeschreibung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Vorhabensbeschreibung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Vorhabensbeschreibung_Ueberarbeitet_Am.path,
				},
				Durchfuehrung: {
					PruefStatus: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Ueberarbeitet_Am.path,
				},
				Erfolgskontrolle: {
					PruefStatus: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Erfolgskontrolle_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Erfolgskontrolle_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Erfolgskontrolle_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Erfolgskontrolle_Ueberarbeitet_Am.path,
				},
			};
		// Kreativwirtschaft
		case ANTRAGS_FORMULAREN.Kreativwirtschaft:
			return {
				Projektbeschreibung: {
					PruefStatus: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Ueberarbeitet_Am.path,
				},
				ProjektDurchfuehrung: {
					PruefStatus: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Ueberarbeitet_Am.path,
				},
				NachweisEffizienz: {
					PruefStatus: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Ueberarbeitet_Am.path,
				},
			};
		// Mobilitätspläne
		case ANTRAGS_FORMULAREN.Mobilitaetsplaene:
			return {
				Foerdervoraussetzung: {
					PruefStatus: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Ueberarbeitet_Am.path,
				},
				Ausgangssituation: {
					PruefStatus: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Ausgangssituation_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Ausgangssituation_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Ausgangssituation_Ueberarbeitet_Am.path,
				},
				// _E steht für Erstellung oder _U steht für Umsetzung. Das sind die gegenStände
				BeschreibungDesVorhabens_E: {
					PruefStatus: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Erstellung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Erstellung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Erstellung_Pruefung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Erstellung_Ueberarbeitet_Am.path,
				},
				BeschreibungDesVorhabens_U: {
					PruefStatus: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Ueberarbeitet_Am.path,
				},
				Begruendung: {
					PruefStatus: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Ueberarbeitet_Am.path,
				},
			};
		// Entwicklungszusammenarbeit
		case ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit:
			return {
				DurchfuehrungOrganisation: {
					PruefStatus: P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Ueberarbeitet_Am.path,
				},
				Projektbeschreibung: {
					PruefStatus: P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Ueberarbeitet_Am.path,
				},
			};
		// Löwe
		case ANTRAGS_FORMULAREN.Loewe:
			return {
				Ausgangsituation: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Ueberarbeitet_Am.path,
				},
				TechnologischeBeschreibung: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Ueberarbeitet_Am.path,
				},
				Innovationsgrad: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Ueberarbeitet_Am.path,
				},
				Marktanalyse: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Marktanalyse_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Marktanalyse_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Marktanalyse_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Marktanalyse_Ueberarbeitet_Am.path,
				},
				WissenschaftlicheEffekte: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Ueberarbeitet_Am.path,
				},
				MeilensteinePlanung: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Meilensteinplanung_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Meilensteinplanung_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Meilensteinplanung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Meilensteinplanung_Ueberarbeitet_Am.path,
				},
				Standorteffekte: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Transfer_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Transfer_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Transfer_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Transfer_Ueberarbeitet_Am.path,
				},
				SWOT: {
					PruefStatus: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Ueberarbeitet_Am.path,
				},
			};
		// Elektrobusse
		case ANTRAGS_FORMULAREN.Elektrobusse:
			return {
				Foerdervoraussetzung: {
					PruefStatus: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Foerdervoraussetzungen_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Foerdervoraussetzungen_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Foerdervoraussetzungen_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Foerdervoraussetzungen_Ueberarbeitet_Am.path,
				},
				Ausgangsituation: {
					PruefStatus: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Ueberarbeitet_Am.path,
				},
				// _B steht für Beschaffung und _N steht für Nachrüstung. Das ist der GEgenstand
				BeschreibungDesVorhaben_B: {
					PruefStatus: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Beschaffung_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Beschaffung_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Beschaffung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Beschaffung_Ueberarbeitet_Am.path,
				},
				BeschreibungDesVorhaben_N: {
					PruefStatus: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Nachruestung_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Nachruestung_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Nachruestung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Nachruestung_Ueberarbeitet_Am.path,
				},
				BeschaffungLadeInfrastruktur_N: {
					PruefStatus: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ladeinfrastruktur_Nachruestung_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ladeinfrastruktur_Nachruestung_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ladeinfrastruktur_Nachruestung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ladeinfrastruktur_Nachruestung_Ueberarbeitet_Am.path,
				},
				BeschaffungWasserstoff_N: {
					PruefStatus: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Ueberarbeitet_Am.path,
				},
				AusschreibungVergabe: {
					PruefStatus: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausschreibung_Vergabe_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausschreibung_Vergabe_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausschreibung_Vergabe_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausschreibung_Vergabe_Ueberarbeitet_Am.path,
				},
			};
		// Logistik und Mobilität
		case ANTRAGS_FORMULAREN.LogistikUndMobilitaet:
			return {
				BeschreibungDesVorhabens: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Projektziel_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Projektziel_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Projektziel_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Projektziel_Ueberarbeitet_Am.path,
				},
				StandDerTechnik: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Stand_Der_Technik_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Stand_Der_Technik_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Stand_Der_Technik_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Stand_Der_Technik_Ueberarbeitet_Am.path,
				},
				Entwicklungsstand: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Entwicklungsstand_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Entwicklungsstand_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Entwicklungsstand_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Entwicklungsstand_Ueberarbeitet_Am.path,
				},
				DarlegungInnovation: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Darlegung_Innovation_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Darlegung_Innovation_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Darlegung_Innovation_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Darlegung_Innovation_Ueberarbeitet_Am.path,
				},
				WettbewerbVerwertung: {
					PruefStatus:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Wirtschaftliche_Verwertung_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Wirtschaftliche_Verwertung_Hinweis_Antragsteller
							.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Wirtschaftliche_Verwertung_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Wirtschaftliche_Verwertung_Ueberarbeitet_Am.path,
				},
				SWOT: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_SWOT_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_SWOT_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_SWOT_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_SWOT_Ueberarbeitet_Am.path,
				},
				DurchfuehrungHOLM: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Ueberarbeitet_Am.path,
				},
				KommunikationMassnahme: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Oeffentlichkeitsarbeit_Pruefstatus.path,
					PruefHinweis:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Oeffentlichkeitsarbeit_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Oeffentlichkeitsarbeit_Erledigt.path,
					UeberarbeitetAm:
						P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Oeffentlichkeitsarbeit_Ueberarbeitet_Am.path,
				},
				Qualifikation: {
					PruefStatus: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Kompetenzen_Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Kompetenzen_Hinweis_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Kompetenzen_Erledigt.path,
					UeberarbeitetAm: P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Kompetenzen_Ueberarbeitet_Am.path,
				},
			};
		// Start-Up-Stipendium
		case ANTRAGS_FORMULAREN.StartUpStipendium:
			return {
				Projektbeschreibung: {
					PruefStatus: P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Pruefstatus.path,
					PruefHinweis: P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Hinweis_Fuer_Den_Antragsteller.path,
					IstErledigt: P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Erledigt_Durch_Antragsteller.path,
					UeberarbeitetAm: P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Ueberarbeitet_Am.path,
				},
			};
	}

	return paths;
};
